/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:00b65b9f-768e-4a9b-bbaa-d662b290b0bd",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_1bmzmKPTM",
    "aws_user_pools_web_client_id": "7edp4rcb0ku2le9arbjmjpg504",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://qaaawptodzaannowpzli5f7sou.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-34cxz3viqrdojgqrnnm7vwdesq",
    "aws_user_files_s3_bucket": "bhargavitailors64ccaf3318e8441e90cd05ce644531f812908-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
